<template>
  <div class="table-wrapper px-2 py-2">
  <v-data-table
    header-text="label"
    :items="items"
    :headers="usableHeaders"
    :pagination.sync="sorter"
    :total-items="totalCount"
    :rows-per-page-items="[12, 24, 32]"
    >
    <template slot="headers" slot-scope="props">
      <gheader
        :headers="usableHeaders"
        :hasActions="hasActions"
        :pagination="pagination"
        :handleSort="handleSort"
      />
    </template>
    <template slot="items" slot-scope="props">
      <gitem
        :item="props.item"
        :selection="selection"
        :headers="usableHeaders"
        :emitSelection="emitSelection"
        :actions="actions"
        :hasActions="hasActions"
      />
    </template>
    <template slot="no-data">
      <tr>
        <td :colspan="noDataSpan">
          <v-alert :value="true" color="warning" icon="warning">
            Pas encore de données
          </v-alert>
        </td>
      </tr>
    </template>
  </v-data-table>
  </div>
</template>

<script>
import _ from 'lodash'
import TableItem from '@/components/list/TableItem'
import TableHeader from '@/components/list/TableHeader'

export default {
  components: {
    gitem: TableItem,
    gheader: TableHeader,
  },
  props: {
    items: Array,
    unfiltered: Array,
    emitSelection: Function,
    pagination: Object,
    handleSort: Function,
    updatePagination: Function,
    selection: Array,
    headers: Array,
    actions: Array,
    hasActions: Boolean,
    totalCount: Number,
  },
  computed: {
    usableHeaders () { return _.reject(this.headers, {inTable: false}) },
    sorter: {
      get () { return this.pagination },
      set (value) { this.updatePagination(value) },
    },
    noDataSpan () { return this.hasActions ? this.headers.length + 2 : this.headers.length + 1 },
  },
}
</script>
<style>
.table-wrapper {
  background-color: white;
}
</style>
